import { useState, useRef, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useToken } from '../TokenContext.js';
import './ChatBox.css';
import { v4 as uuidv4 } from 'uuid';
// import loader from './../assets/loader_v1.gif';
import PropTypes from 'prop-types';

const ChatBox = ({currentSession, updateQuery, updateQueryResponse, editMessage, updateSession, username, updateEditMessage }) => {

  ChatBox.propTypes = {
    currentSession: PropTypes.object.isRequired,
    updateQuery: PropTypes.func.isRequired,
    updateQueryResponse: PropTypes.func.isRequired,
    editMessage: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    updateEditMessage: PropTypes.func.isRequired,
  };
  
  const token= useToken().token;
  const [message, setMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFullImageVisible, setIsFullImageVisible] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const inputRef = useRef(null);
  const abortControllerRef = useRef(null); // Reference to AbortController

  const companyName = useToken().companyName;

  useEffect(() => {//console.log("jjjjjjjjjjjjjjj",editMessage);
    if (editMessage !== undefined||editMessage!== null) {
      //console.log("dddddddddddd", editMessage);
      setMessage(editMessage);
    }
  }, [editMessage]);

  useEffect(() => {
    adjustTextareaHeight();
  }, [message]);


  const handleInputChange = (e) => {
    //console.log("dddddddddddd",e.target.value);
    setMessage(e.target.value);
    updateEditMessage(null);
    adjustTextareaHeight();
  };

  const adjustTextareaHeight = () => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = `${Math.min(inputRef.current.scrollHeight, 280)}px`;
    }
  };

  //Is to be uncommented when file handling is to be done - Do not Delete

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSelectedFile(URL.createObjectURL(file));
  //   }
  // };

  const handleRemoveImage = () => {
    setSelectedFile(null);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setMessage(''); // Clear the input value on Esc
      updateEditMessage(null);
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submitQuery();
      setMessage('');
      setSelectedFile(null); // Clear the image on send
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
  
    // Get the pasted data
    const pastedText = e.clipboardData.getData('Text');
  
    // Update the message state directly
    setMessage((prevMessage) => prevMessage + pastedText);
  };
  
  

  const submitQuery = () => {
    if (message.trim() === '') return; // Prevent empty messages from being sent
  
    setLoading(true); // Set loading to true when query is submitted
  
    const abortController = new AbortController();
    abortControllerRef.current = abortController;
  
    const apiUrl = `https://infia.enviseer.com/api/llm/query`;
  
    const queryData = {
      query: message,
      session_id: currentSession,
      company: companyName,
      doc_type: "HR",
      query_type: "query",
      email: username,
    };
  
    updateQuery(message);
  
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(queryData),
      signal: abortController.signal // Pass the signal to fetch to enable abortion
    })
      .then((response) => {
    if (response.status === 401) {
      // Redirect to the login page if unauthorized
      window.location.href = 'https://infia.enviseer.com/';
      return; // Stop further processing
    }
    return response.json(); // Parse the JSON response if the status is not 401
  })
      .then((data) => {
        //console.log('Response from server:', data);
        updateQueryResponse(data.response); // No need to check `loading` again
        setMessage(''); // Clear the message input after successful submission
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          //console.log('Fetch request was aborted');
        } else {
          console.error('Error during fetch:', error);
        }
      })
      .finally(() => {
        setLoading(false); // Set loading back to false whether success or error
      });
  };
  
  // Function to stop loading manually by clicking the loading spinner
  const stopLoading = async () => {
    if (loading) {
      // Abort the ongoing fetch request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
  
      setLoading(false);
  
      updateQueryResponse("It seems like you've stopped the conversation. If you'd like to continue, feel free to ask again");
      //console.log('Loading process stopped manually.');
  
      // Add a delay before calling the delete request (e.g., 1 second)
      setTimeout(async () => {
        // Delete the latest user input and its response
        try {
          const response = await fetch('http://localhost:9060/conversation_history/delete_latest', {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              session_id: "4d3f4e2e-2532-41a9-9974-4d652de09a16", // replace with actual session_id
              user_input: "How to update my personal information?" // dynamically set the latest user_input
            }),
          });
  
          const result = await response.json();
          //console.log(result.message); // Display success message
        } catch (error) {
          console.error('Error deleting the latest question and response:', error);
        }
      }, 3000); // Delay of 1 second (1000ms) before calling the delete API
    }
  };
   const newSession = () => {
    // Set session ID in state
    //console.log("new session created", uuidv4());
    updateSession(uuidv4());
    //setSelectedSession('null');
  };

  return (
    <div className="chat-box-container">
       <div className="new-session-mobile d-block d-md-none" onClick={newSession}>
        <button className={'new-button'}>
          <i className={ 'bi-plus-circle'} style={{ fontSize: '16px' }}></i>
        </button>
      </div>
          {/* <label htmlFor="file-input" className="file-input-label">
            <i className="bi bi-paperclip"></i>
          </label>
          <input
            type="file"
            id="file-input"
            className="file-input"
            onChange={handleFileChange}
            accept=".pdf, .jpg, .jpeg, .png, .txt"
          /> */}
      <div className="chat-box">
        <div className="input-container">
          {selectedFile && (
            <div className="image-preview-container">
              <div className="image-preview" onClick={() => setIsFullImageVisible(true)}>
                <img src={selectedFile} alt="Preview" />
              </div>
              <i
                className="bi bi-x-circle-fill remove-image-icon"
                onClick={handleRemoveImage}
                style={{ marginLeft: '-10px', marginTop: '-36px', zIndex: '999' }}
              ></i>
            </div>
          )}
          <textarea
            ref={inputRef}
            className="chat-input"
            placeholder="Ask EnviBuddy..."
            value={message}
            onChange={handleInputChange}
            onPaste={(e) => {
              handlePaste(e);
            }}
            onKeyDown={handleKeyDown}
            rows="1"
            style={{maxHeight: message===''? '35px': '280px', marginBottom: '-15px' }}
          />
        </div>
       
      </div>
      <button
          className="send-button"
          onClick={loading ? stopLoading : submitQuery} // Stop loading if loading, else submit query
          disabled={loading && false} // Allow click during loading to stop it
        >
          {loading ? (
            <i className="bi bi-arrow-repeat loading-spinner"></i> // Bootstrap spinner icon
          ) : (
            <i className="bi bi-send-fill"></i> // Send icon when not loading
          )}
        </button>
      {isFullImageVisible && (
        <div className="full-image-overlay" onClick={() => setIsFullImageVisible(false)}>
          <img src={selectedFile} alt="Full Preview" className="full-image" />
        </div>
      )}
    </div>
  );
};

export default ChatBox;
